<template>
    <div>
        <self-back :pageHeaderList="[{'name':'上饶易效配置'}]"></self-back>
        <div class="content" v-loading='loading'>
            <button class="addaccountButton" @click="addaccountEvent">+ 上饶易效比例配置</button>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="accountList"
                :max-height="tableMaxHeight"
                border
                >
                <el-table-column
                prop="rebate"
                label="上饶易效比例配置"
                align='center'
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="month_format"
                align='center'
                label="时间"
                >
                </el-table-column>
                <el-table-column
                align='center'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyaccountEvent(scope.row)">修改</button>
                        <button style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox" style="height: 30px;">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    @current-change="handleCurrentChange"
                    :page-size="page_size"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加账号 -->
        <el-dialog
            :title="isEdit?'修改上饶易效比例配置':'添加上饶易效比例配置'"
            :visible.sync="addaccountFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem" style="margin-bottom: 20px;">
                    <label><em>*</em>上饶易效比例配置：</label>
                    <el-input
                        placeholder="请输入上饶易效比例配置"
                        style="width:56%"
                        v-model.trim="accountName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>时间：</label>
                    <el-date-picker
                        style="width:56%"
                        v-model="timeMonth"
                        type="month"
                        size="mini"
                        value-format="yyyy-MM"
                        placeholder="选择时间">
                    </el-date-picker>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
                <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addaccountFlag:false,
            deleteaccountFlag:false,
            accountList:[],
            accountName:'',
            page:1,
            page_size:20,
            total:0,
            loading:false,
            isEdit:false,
            timeMonth:'',
            vebateId:'',
            type:3
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + button(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
            return window.innerHeight - 326;
        }
    },
    created(){
        this.accountsListEvent(1)
    },
    methods:{
        addaccountEvent(){//点击添加账号按钮
            this.addaccountFlag = true;
            this.isEdit = false;
        },
        deleteaccountFlagEvent(data){//删除账号
            this.$confirm('确定要删除该配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.rebateDel,{
                        id: data.id,
                        type: this.type
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.accountsListEvent(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {        
            });
        },
        handleCurrentChange(val){
            this.accountsListEvent(val)
        },
        accountsListEvent(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.rebateList,{
               params:{
                   page: page,
                   page_size: this.page_size,
                   type:this.type,
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.accountList = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addaccountYes(){//添加账号
            if(this.accountName == ''){
                this.$message({
                    message: '请输入上饶易效比例配置',
                    type: 'fail'
                })
                return
            }
            if(this.timeMonth == ''){
                this.$message({
                    message: '请选择配置日期',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.rebateEdit,{
                    rebate: this.accountName,
                    month: this.timeMonth,
                    id: this.vebateId,
                    type: this.type
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                this.$axios.post(this.URL.BASEURL + this.URL.rebateAdd,{
                    rebate: this.accountName,
                    month: this.timeMonth,
                    type: this.type
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        cancelAddaccount(){//取消添加账号
            this.addaccountFlag = false;
            this.accountName = '';
            this.timeMonth = '';
        },
        modifyaccountEvent(data){//修改账号
            this.accountName = data.rebate;
            this.timeMonth = (data.month_format.replace(/\年/g,'-')).replace(/\月/g,'');
            this.vebateId = data.id;
            this.isEdit = true;
            this.addaccountFlag = true;
        }
    },
    watch:{
       
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 15px;
    // display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .addaccountButton{
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        padding:0 10px;
        flex-shrink: 0;
    }
    .table{
        margin-top: 15px;
        flex: 1;
        min-height: 0;
        button{
            min-width: 48px;
            height: 22px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
    .paginationBox{
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 0;
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 150px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
        em{
            color: red;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/sryxConfigure.vue